import * as React from 'react';
import { observer } from 'mobx-react';
import { OptionDescription } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import getStore from '../store/store';
import requestMailboxExport from '../actions/requestMailboxExport';
import ExportMailboxStatus from '../components/ExportMailboxStatus';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

const styles = require('./ExportMailbox.scss');

@observer
export default class ExportMailbox extends React.Component<{}, {}> {
    render() {
        const { isExportMailboxRequestMade, downloadLink } = getStore();
        if (!getUserConfiguration().SessionSettings.IsShadowMailbox) {
            return (
                <div>
                    <OptionDescription>
                        {strings.option_description_1_export_mailbox}
                    </OptionDescription>
                    <OptionDescription>
                        {strings.option_description_2_export_mailbox}
                    </OptionDescription>
                    <div className={styles.buttonStatusLine}>
                        <PrimaryButton
                            text={strings.option_export_mailbox_button_label}
                            disabled={isExportMailboxRequestMade !== false && !downloadLink}
                            onClick={requestMailboxExport}
                        />
                        {isExportMailboxRequestMade === undefined ? (
                            <Spinner />
                        ) : (
                            <ExportMailboxStatus />
                        )}
                    </div>
                </div>
            );
        } else {
            return (
                <div>
                    <OptionDescription>
                        {strings.option_description_export_shadow_mailbox}
                    </OptionDescription>
                </div>
            );
        }
    }
}
